<app-logifit-menu-row
  *ngIf="triggerStyle === 'profile'"
  [triggerId]="triggerId"
  icon="people-outline"
  label="Account wisselen">
</app-logifit-menu-row>

<ion-item *ngIf="triggerStyle === 'menu'" [id]="triggerId" button detail="false" class="menu-trigger">
  <ion-icon slot="start" name="people-outline"></ion-icon>
  <ion-label>Account wisselen</ion-label>
</ion-item>

<ion-modal #modal [trigger]="triggerId" class="ds-dialog-modal" (willPresent)="onModalWillPresent()">
  <ng-template>
    <div class="ds-dialog-card">

      <button type="button" class="ds-dialog-close" (click)="modal.dismiss()" aria-label="Sluiten">
        <ion-icon name="close-outline"></ion-icon>
      </button>

      <div class="ds-dialog-head">
        <span class="ds-dialog-title">Account wisselen</span>
        <span class="ds-dialog-subtitle">Kies een profiel of voeg een nieuwe gebruiker toe</span>
      </div>

      <div class="ds-dialog-body">
        <button type="button" class="dlg-add" (click)="logout()">
          <div class="dlg-add-icon">
            <ion-icon name="person-add-outline"></ion-icon>
          </div>
          <span class="dlg-add-text">Ander account toevoegen</span>
          <ion-icon name="chevron-forward-outline" class="dlg-add-chevron"></ion-icon>
        </button>

        <app-logifit-cached-profiles-list #profileList
          [listId]="triggerId + '-profiles'"
          (profileSelect)="login($event.username, $event.password)">
        </app-logifit-cached-profiles-list>
      </div>

    </div>
  </ng-template>
</ion-modal>
